import script from "./TechnicalAnalytics.vue?vue&type=script&setup=true&lang=ts"
export * from "./TechnicalAnalytics.vue?vue&type=script&setup=true&lang=ts"

import "./TechnicalAnalytics.vue?vue&type=style&index=0&id=128fbe98&lang=css"

const __exports__ = script;

export default __exports__